import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const membershipTypes = [
  {
    id: 'full',
    name: 'Full Membership',
    price: '£50',
    description: 'Access to all club facilities and events',
    benefits: [
      'Full access to club facilities',
      'Priority booking for events',
      'Monthly club magazine',
      'Voting rights at AGM',
    ],
  },
  {
    id: 'social',
    name: 'Social Membership',
    price: '£25',
    description: 'Access to social events and limited facilities',
    benefits: ['Access to social events', 'Monthly club magazine', 'Member rates at the club bar'],
  },
];

function RenewalMembership() {
  const navigate = useNavigate();
  const [selectedType, setSelectedType] = useState('full');

  const handleSubmit = e => {
    e.preventDefault();
    navigate('/renewal/payment');
  };

  return (
    <div className="max-w-3xl mx-auto">
      <h1 className="text-2xl font-bold text-white mb-6">Select Membership Type</h1>

      <form onSubmit={handleSubmit} className="space-y-6">
        <div className="grid md:grid-cols-2 gap-6">
          {membershipTypes.map(type => (
            <button
              key={type.id}
              type="button"
              className={`w-full bg-white/5 rounded-lg p-6 cursor-pointer border-2 transition-colors text-left ${
                selectedType === type.id ? 'border-hdlcc-lightBlue' : 'border-transparent'
              }`}
              onClick={() => setSelectedType(type.id)}
              onKeyDown={e => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  setSelectedType(type.id);
                }
              }}
              aria-label={`Select ${type.name}`}
            >
              <div className="flex items-start">
                <input
                  type="radio"
                  name="membershipType"
                  value={type.id}
                  checked={selectedType === type.id}
                  onChange={() => setSelectedType(type.id)}
                  className="mt-1"
                />
                <div className="ml-4">
                  <h3 className="text-lg font-semibold text-white">{type.name}</h3>
                  <p className="text-xl font-bold text-hdlcc-lightBlue mt-1">{type.price}</p>
                  <p className="text-gray-300 mt-2">{type.description}</p>
                  <ul className="mt-4 space-y-2">
                    {type.benefits.map((benefit, index) => (
                      <li key={index} className="text-gray-300 flex items-center">
                        <span className="text-hdlcc-lightBlue mr-2">✓</span>
                        {benefit}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </button>
          ))}
        </div>

        <div className="flex justify-between mt-8">
          <button
            type="button"
            onClick={() => navigate('/renewal')}
            className="text-hdlcc-lightBlue hover:text-hdlcc-blue"
          >
            ← Back
          </button>
          <button
            type="submit"
            className="bg-hdlcc-lightBlue text-white px-8 py-3 rounded-lg hover:bg-hdlcc-blue transition-colors"
          >
            Continue to Payment
          </button>
        </div>
      </form>
    </div>
  );
}

export default RenewalMembership;
